import { RadioOutlineCardBrand } from '@npco/zeller-design-system'
import styled from 'styled-components'

import { ReactComponent as InfoIcon } from 'assets/svg/info.svg'

export const StyledList = styled.div`
  max-width: 512px;
`

export const TransparentButton = styled.button.attrs({ type: 'button' })`
  width: 100%;
  background: transparent;
  border: 0;
  margin: 0 0 0 -8px;
  padding: 0;
  text-align: left;
`

export const StyledRadioOutlineCardBrand = styled(RadioOutlineCardBrand)`
  padding: 10px 16px 10px 8px;
  border: none;
  margin: 0;
`

export const StyledInfoIcon = styled(InfoIcon)`
  path {
    fill: ${({ theme }) => theme.colors.RED_1000};
  }
`
